import { Context, useContext } from 'react';
import { StoreApi, useStore } from 'zustand';

export interface UseStore<TStore> {
  (): TStore;

  <T>(selector: (state: TStore) => T): T;
}

export const createUseStore = <TStore>(
  context: Context<StoreApi<TStore> | null>,
  contextName: string,
): UseStore<TStore> => {
  return <T>(selector?: (state: TStore) => T) => {
    const store = useContext(context);

    /* istanbul ignore if */
    if (!store) {
      throw new Error(`Missing ${contextName}.Provider in the tree`);
    }

    return useStore(store, selector!);
  };
};
